import type { ReactElement } from 'react';

import { useFlexiForwardSelector } from '@/App/tiles/FlexiForward/FlexiForwardContext.ts';
import { FlexiForwardFormField } from '@/App/tiles/FlexiForward/FlexiForwardTile/common/form/FlexiForwardFormField.tsx';
import { DatePickerWithTenorNext } from '@/components/ui/DatePickerWithTenorNext.tsx';
import { useFlexiForwardPropertyChangedHandler } from '@/store/flexi-forward/hooks/useFlexiForwardPropertyChangedHandler.ts';
import { DEFAULT_SOLVING_TYPE } from '@/store/flexi-forward/state.ts';

export function PremiumDatePicker({ tileId }: { tileId: string }): ReactElement | null {
  const { premiumDate, premiumDateTenor, solvingType } = useFlexiForwardSelector((flexiForward) => {
    const properties = flexiForward.properties;

    return {
      premiumDate: properties.premiumDate,
      premiumDateTenor: properties.premiumDateTenor,
      solvingType: properties.solvingType ?? DEFAULT_SOLVING_TYPE,
    };
  });

  const handlePremiumDateChanged = useFlexiForwardPropertyChangedHandler<string>(
    tileId,
    'Premium date changed',
    (dateStringOrTenor) => ({ premiumDate: dateStringOrTenor }),
  );

  return solvingType === 'zeroCost' ? null : (
    <FlexiForwardFormField formattedMessageId="flexiForwardTile.mainFields.premiumDate.label">
      <DatePickerWithTenorNext date={premiumDate ?? ''} tenor={premiumDateTenor} onChange={handlePremiumDateChanged} />
    </FlexiForwardFormField>
  );
}
